$(function() {
    $(document).ready(function() {
        if ($('.team')[0]) {
            const parent = $('.team__item');
            const btn = $('.team__item figure, .team__toggle');
            const content = $('.team__itemContent');

            $(btn).click(function() {
                var parentElement = $(this).closest(parent);
                var contentToToggle = parentElement.find(content);

                $(parent)
                    .not(parentElement)
                    .removeClass('active');
                $(content)
                    .not(contentToToggle)
                    .slideUp();

                parentElement
                    .toggleClass('active')
                    .find(content)
                    .slideToggle();
            });

            $(window).resize(function() {
                if (window.innerWidth < 767) {
                    $(parent).removeClass('active');
                    $(content).removeAttr('style');
                }
            });

            function updateLayout() {
                var teamItems = document.querySelectorAll('.team__item');
                var parent = document.querySelector('.team__groups');

                if (window.innerWidth < 767) {
                    while (parent.firstChild) {
                        parent.removeChild(parent.firstChild);
                    }

                    teamItems.forEach(function(item) {
                        parent.appendChild(item);
                    });
                } else {
                    parent.innerHTML = '';

                    var itemsPerGroup = Math.ceil(teamItems.length / 3);

                    for (var i = 0; i < teamItems.length; i += itemsPerGroup) {
                        var wrapper = document.createElement('div');
                        wrapper.className = 'team__group';

                        for (var j = i; j < i + itemsPerGroup && j < teamItems.length; j++) {
                            wrapper.appendChild(teamItems[j]);
                        }

                        parent.appendChild(wrapper);
                    }
                }
            }

            window.onload = function() {
                updateLayout();
                window.addEventListener('resize', updateLayout);
            };
        }
    });
});
